import { render, staticRenderFns } from "./after-order.vue?vue&type=template&id=67f9f6c3&scoped=true&"
import script from "./after-order.vue?vue&type=script&lang=js&"
export * from "./after-order.vue?vue&type=script&lang=js&"
import style0 from "./after-order.vue?vue&type=style&index=0&id=67f9f6c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f9f6c3",
  null
  
)

export default component.exports